import React from 'react';
import { t, Trans } from '@lingui/macro';
import styled, { css } from 'styled-components/native';

import ImageIcon from '@src/components/ImageIcon';
import { Subtitle2 } from '@src/components/Typography';
import { i18n } from '@src/i18n';
import { Source } from '@src/types/source';
import { Platform } from 'react-native';

type Props = {
  color?: string;
  size?: number;
  source: number | Source;
  title?: string;
};
type PropText = {
  color?: string;
};
const Column = styled.View`
  ${Platform.select({
    ios: css`
      width: 130px;
    `,
    web: css`
      width: 100%;
    `,
  })};
  flex-direction: column;
  align-items: center;
  height: 42px;
  flex-wrap: nowrap;
`;
const Title = styled(Subtitle2)<PropText>`
  color: ${({ color }) => color};
`;

const TabItem: React.FC<Props> = ({ title, color, size, source }) => {
  return (
    <Column>
      <ImageIcon source={source} color={color} size={size ? size : 24} />
      {title && <Title color={color}>{title}</Title>}
    </Column>
  );
};

export default TabItem;
